module.exports = __webpack_public_path__ + "static/media/perfectWedding1.43d903fe.png";